import { CustomerGateway } from '../domain/customer.gateway';
import { GetRelated } from '../domain/customer.entity';

export class GetRelatedUseCase {
    constructor(private gate: CustomerGateway) {}

    async execute(params: GetRelated): Promise<any[]> {
        return this.gate.getRelated(params);
    }
}